"use client";
import { Challenge } from "@/lib/challengePaths";
import { OptionButton } from "../ui/OptionButton";
import { FC } from "react";
import { EstimateChallengeForm } from "./EstimateChallengeForm";

interface Props {
  challenge: Challenge;
  estimateInput: string;
  handleChoiceAnswer: (choiceIndex: number) => void;
  handleEstimateInput: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleEstimateSubmit: () => void;
}
export const ChallengeQuestionContent: FC<Props> = ({
  challenge,
  estimateInput,
  handleChoiceAnswer,
  handleEstimateInput,
  handleEstimateSubmit,
}) => {
  if (challenge.type === "choice") {
    return (
      <>
        <p className="text-lg text-white mb-4">{challenge.question}</p>
        <div className="space-y-3">
          {challenge.options?.map((option, index) => (
            <OptionButton
              key={option}
              onClick={() => handleChoiceAnswer(index)}
            >
              {option}
            </OptionButton>
          ))}
        </div>
      </>
    );
  } else if (challenge.type === "estimate") {
    return (
      <EstimateChallengeForm
        challenge={challenge}
        estimateInput={estimateInput}
        handleEstimateInput={handleEstimateInput}
        handleEstimateSubmit={handleEstimateSubmit}
      />
    );
  }

  return (
    <div className="text-red-400">
      <p>Unknown challenge type: {challenge.type}</p>
    </div>
  );
};
